import { styled } from '@linaria/react';

export const LoaderWrapper = styled.div<{ size: number; plane?: boolean }>`
	display: flex;
	width: ${({ plane }) => (plane ? 'auto' : '100%')};
	height: ${({ plane }) => (plane ? 'auto' : '100%')};

	svg {
		width: ${({ size }) => size + 'px'};
		height: ${({ size }) => size + 'px'};
		margin: auto;
	}
`;
